function Spinner() {
  return (
    <div className="spinner mx-auto"></div>
  )
}

export default Spinner